import { createContext, useContext, useState, useEffect } from 'react';
import websocketClient from '../services/websocket';

const WebSocketContext = createContext({
  isConnected: false,
});

export const useWebSocket = () => useContext(WebSocketContext);

export const WebSocketProvider = ({ children }) => {
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // 连接 WebSocket
    websocketClient.connect();

    // 监听连接状态
    const handleConnected = () => {
      setIsConnected(true);
    };

    const handleDisconnected = () => {
      setIsConnected(false);
    };

    websocketClient.on('connected', handleConnected);
    websocketClient.on('disconnected', handleDisconnected);

    return () => {
      websocketClient.off('connected', handleConnected);
      websocketClient.off('disconnected', handleDisconnected);
    };
  }, []);

  return (
    <WebSocketContext.Provider value={{ isConnected }}>
      {children}
    </WebSocketContext.Provider>
  );
};
